<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M16.0347 3.3L20.7147 7.98C20.8947 8.16 21.0047 8.42 20.9947 8.68V15.32C20.9947 15.59 20.8947 15.84 20.7047 16.03L16.0247 20.71C15.8347 20.89 15.5847 21 15.3147 21H8.6847C8.4247 21 8.1647
     20.89 7.9747 20.7L3.2947 16.02C3.1147 15.83 3.0047 15.58 3.0047 15.31V8.68C3.0047 8.42 3.1147 8.16 3.2947 7.98L7.9847 3.29C8.1647 3.11 8.4247 3 8.6847 3H15.3247C15.5847 3 15.8447 3.11 16.0347
      3.3ZM14.9047 19L19.0047 14.9V9.1L14.9047 5H9.1047L5.0047 9.1V14.9L9.1047 19H14.9047ZM12.0047 15C11.4524 15 11.0047 15.4477 11.0047 16C11.0047 16.5523 11.4524 17 12.0047 17C12.557 17 13.0047
       16.5523 13.0047 16C13.0047 15.4477 12.557 15 12.0047 15ZM11.0047 8C11.0047 7.45 11.4547 7 12.0047 7C12.5547 7 13.0047 7.45 13.0047 8V13C13.0047 13.55 12.5547 14 12.0047 14C11.4547 14 11.0047
        13.55 11.0047 13V8Z"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ReportOutlined' /* In GMD called report_gmailerrored */
  }
</script>
